export default __webpack_public_path__ + "static/media/withdrawal-labs.a9705687.svg";